import React, { memo } from "react"
import { useState } from "react"
import { Animated } from "react-animated-css"
import Img from "gatsby-image"
import { Typography } from "antd"
import { Link } from "gatsby"
import InfoModal from "../components/InfoModal"
const { Title } = Typography

const StaffaugmentationHeader = ({ data }) => {
    const [isModalVisible, setIsModalVisible] = useState(false)

    const showModal = () => {
        setIsModalVisible(true)
    }

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const handleCancel = () => {
        setIsModalVisible(false)
    }
    const backgroundImage = data.bgImage.childImageSharp.fluid.src
    return (
        <div
            className="top-section"
            style={{ backgroundImage: `url(${backgroundImage})` }}
        >
             <div className="box-wrapper text-and-form-container" style={{ gridTemplateColumns: '1fr', textAlign: 'center' }}>
                <div className="information">
                    <Animated
                        animationIn="fadeInUp"
                        animationInDuration={500}
                        animationInDelay={300}
                        isVisible={true}
                    >
                        <Title>Scale Your Team with AI-Ready Tech Talent, On Demand</Title>
                        <br />
                        <p>
                            Hiring cycles are slow. Project demands aren't. We give you immediate access to senior engineers, AI specialists, and full-stack developers who embed into your team, match your processes, and deliver from day one — without the overhead of permanent headcount.
                        </p>
                    </Animated>
                </div>
            </div>
            {/* <button onClick={showModal}>Tell us about your project</button>
            <InfoModal
                companyIsEnabled
                url="http://46.101.195.121:8066/email/ContactUs"
                isModalVisible={isModalVisible}
                handleOk={handleOk}
                handleCancel={handleCancel}
            /> */}
        </div>
    )
}

export default memo(StaffaugmentationHeader)
